import { Stack } from '@mui/system'
import { LocalizationProvider, TimePicker, TimePickerProps } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'
import { EFTypography } from '../EFTypography'

interface IEFTimePicker extends TimePickerProps<AdapterMoment> {
  label?: string
}
export function EFTimePicker(props: IEFTimePicker) {
  const isDark = useAppSelector(isDarkTheme)
  const { label, ...otherProps } = props
  return (
    <Stack
      direction='row'
      alignItems='center'
    >
      <EFTypography sx={{ mx: 1 }}>{label}</EFTypography>
      <LocalizationProvider
        dateAdapter={AdapterMoment}
        adapterLocale={'en-us'}
      >
        <TimePicker
          {...otherProps}
          slotProps={{
            popper: {
              sx: {
                '.MuiPaper-root': {
                  background: isDark ? 'var(--dark-chart-bg)' : '',
                  '& li.MuiButtonBase-root.MuiMenuItem-root': {
                    '&:hover': {
                      backgroundColor: isDark ? 'var(--hovered-dark)' : ''
                    }
                  }
                },
                '*': {
                  color: isDark ? 'white !important' : 'var(--dark)',
                  borderColor: isDark ? 'var(--border-dark-color) !important' : ''
                }
              }
            },
            textField: {
              size: 'small',
              sx: {
                my: 1.5,
                '& *': { color: isDark ? 'white !important' : '' },
                '& fieldset': {
                  borderColor: isDark ? 'var(--border-dark-color) !important' : ''
                }
              }
            }
          }}
        />
      </LocalizationProvider>
    </Stack>
  )
}
